<template>
  <div class="flex items-center">
    <data-view-sidebar-comments :isSidebarActive="addNewDataSidebarComments" @closeSidebar="toggleDataSidebarComments" :data="sidebarDataComments" />
    <feather-icon icon="MessageCircleIcon" svgClasses="h-7 w-7" @click.stop="showCommentsDataSidebar(params.data)" />
  </div>
</template>

<script>
import CommentsDataViewSidebar from '../CommentsDataViewSidebar.vue'
export default {
  name: 'CellRendererLink',
  components: {
    'DataViewSidebarComments': CommentsDataViewSidebar
  },
  data () {
    return  {
      // Data Sidebar Comentario
      addNewDataSidebarComments: false,
      sidebarDataComments: {}
    }
  },
  methods: {
    showCommentsDataSidebar (data) {
      const obj = {
        id_client: data.id_client,
        full_name_client: data.full_name_client ? data.full_name_client : `${data.names_client  } ${data.surnames_client}`,
        email_client: data.email_client ? data.email_client : data.email_user
      }
      this.$store.dispatch('fetchUserCommentsForAClient', obj)
      this.$store.dispatch('fetchUserCommentType')
      this.sidebarDataComments = obj
      this.toggleDataSidebarComments(true)
    }, 
    toggleDataSidebarComments (val = false) {
      this.addNewDataSidebarComments = val
    }
  }
}
</script>
